<p-toolbar>
    <div class="p-toolbar-group-left" *ngIf="showLeftGroup">
        <ng-container *ngIf="showDateFilters && !showSingleDate">
            <label for="dataInicio">Data Início:</label>
            <p-calendar id="dataInicio" [(ngModel)]="dataInicio" (onSelect)="onDateSelect()" dateFormat="mm/yy"
                placeholder="Selecione a data de início" [minDate]="dataCriacaoUsuario" [showIcon]="true"
                class="calendar-margin right-margin" view="month">
            </p-calendar>

            <label for="dataFim">Data Fim:</label>
            <p-calendar id="dataFim" [(ngModel)]="dataFim" (onSelect)="onDateSelect()" dateFormat="mm/yy"
                placeholder="Selecione a data de fim" [minDate]="dataCriacaoUsuario" [showIcon]="true"
                class="calendar-margin" view="month">
            </p-calendar>
        </ng-container>

        <ng-container *ngIf="showDateFilters && showSingleDate">
            <label for="date">Período:</label>
            <p-calendar id="date" [(ngModel)]="date" (onSelect)="onDateSelect()" dateFormat="mm/yy"
                placeholder="Selecione o período" [showIcon]="true" class="calendar-margin" view="month">
            </p-calendar>
        </ng-container>

        <button *ngIf="showDownloadButton" (click)="downloadExcel()" pButton label="Download" icon="pi pi-download"
            class="p-button ml-2"></button>

        <ng-content select="[leftContent]"></ng-content>
    </div>

    <div class="p-toolbar-group-right">
        <span class="p-input-icon-left" *ngIf="showSearchInput">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="applySearch($event)" [placeholder]="placeholder" />
        </span>
        <ng-content select="[rightContent]"></ng-content>
    </div>
</p-toolbar>